import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { setConfig } from '../../actions/config';
import { logoutUser } from '../../api/auth';
import ColorsSection from './ColorsSection';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import { push } from 'react-router-redux';
import Widget from '../../elements/Widget';
import '../../css/elements/right-sidebar.css';
import '../../css/ui-elements/buttons.css';
import '../../css/ui-elements/tabs.css';

class Index extends Component {
  constructor() {
    super()
    this.colors = [
      'light',
      'dark',
      'primary',
      'secondary',
      'info',
      'success',
      'warning',
      'danger'
    ];
    this.toggle = this.toggle.bind(this)
    this.state = {
      activeTab: 0
    };
    this.setConfig = this.setConfig.bind(this);
    this.profileHandler = this.profileHandler.bind(this);
    this.logoutHandler = this.logoutHandler.bind(this);
  }

  setConfig(config, color) {
    this.props.setConfig(config, color)
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      })
    }
  }

  profileHandler() {
    this.props.navToProfile();
  }

  logoutHandler() {
    this.props.logout();
  }

  render() {
    if (this.props.config.layout === 'empty-view-1') {
      return <div />
    }
    const userNameStyles = {
      fontSize: '17px',
      padding: '15px',
    };
    let userProfile = null;
    let currentUserInfo = [];
    if (this.props.users && this.props.users.userProfile) {
      userProfile = this.props.users.userProfile;
      // Set user info
      currentUserInfo.push(
        <span>
          <i className="fa fa-user"></i>
          <span style={{ paddingLeft: '5px' }}>
            {userProfile.firstname} {userProfile.lastname} (<b>{userProfile.username}</b>)
          </span>
        </span>
      );
    }
    // TODO: Refactor, create separeted components
    return (
      <div
        className={
          this.props.rightSidebar
            ? 'right-sidebar-outer show-from-right'
            : 'right-sidebar-outer'
        }>
        <div className="right-sidebar-inner">
          <div className="right-sidebar">
            <h3 style={userNameStyles}>{currentUserInfo}</h3>
            <div className="nav-tabs-primary">
              <Nav tabs className="nav-vertical">
                <NavItem>
                  <NavLink
                    className={this.state.activeTab === 0 ? 'active' : ''}
                    onClick={() => this.toggle(0)}>
                    Profile
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={this.state.activeTab === 1 ? 'active' : ''}
                    onClick={() => this.toggle(1)}>
                    Settings
                  </NavLink>
                </NavItem>
              </Nav>
              <TabContent activeTab={this.state.activeTab.toString()}>
                <TabPane tabId="0">
                  <br/>
                  <button className={'btn btn-default btn-outline col-md-12'} onClick={this.profileHandler}>
                    <b className="float-left">Profile</b>
                    <i className="fa fa-chevron-right float-right"></i>
                  </button>
                  <br/><br/>
                  <button className={'btn btn-default btn-outline col-md-12'} onClick={this.logoutHandler}>
                    <b className="float-left">Logout</b>
                    <i className="fa fa-chevron-right float-right"></i>
                  </button>
                </TabPane>
                <TabPane tabId="1">
                  <ColorsSection
                    title="Navbar color"
                    colors={this.colors}
                    onClick={this.setConfig}
                    config={'navbar'}
                  />
                  <ColorsSection
                    title="Top navigation color"
                    colors={this.colors}
                    onClick={this.setConfig}
                    config={'topNavigation'}
                  />
                  <ColorsSection
                    title="Logo color"
                    colors={this.colors}
                    onClick={this.setConfig}
                    config={'logo'}
                  />
                  <ColorsSection
                    title="Left sidebar color"
                    colors={this.colors}
                    onClick={this.setConfig}
                    config={'leftSidebar'}
                  />
                </TabPane>
              </TabContent>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state, ownProps) => {
  return {
    config: state.config,
    navbarColors: state.config.navbarColors,
    leftSidebarColors: state.config.leftSidebarColors,
    colors: state.colors,
    backgroundColors: state.backgroundColors,
    rightSidebar: state.config.rightSidebar,
    auth: state.auth,
    users: state.users
  }
}
const mapDispatchToProps = dispatch => {
  return {
    setConfig: (key, value) => dispatch(setConfig(key, value)),
    navToProfile: () => {
      dispatch(push('/pages/profile'));
      dispatch(setConfig('rightSidebar', false));
    },
    logout: () => {
      logoutUser({})(dispatch);
    }
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(Index);



// WEBPACK FOOTER //
// ./src/elements/right-sidebar/index.js